import {createGlobalStyle} from 'styled-components';
import {getToastifyStyles} from './tostify';

const GlobalStyle = createGlobalStyle<{fontFaces?: string}>`
  html,
  body,
  #root {
    /* margin: 0; */
    height: 100%;
    font-family: ${props => props.theme.fonts.fontFamily.body.font_name}, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 400;
    box-sizing: border-box;
    background-color: ${props => props.theme.colors.branding.backgroundMain};
    color: ${props => props.theme.colors.branding.fontPrimary};
    margin: 0;
    --sidebar-width: 284px;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  a {
    text-decoration: none;
  }

  button {
    font-family: inherit;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
  }

  input {
    color: inherit;
  }

  .active-nav-link div {
    color: #23262F;
    font-weight: 600;
  }

  .active-nav-link div::before {
    content: '';
    position: absolute;
    width: 100%;
    display: block;
    border-bottom: 2px solid #23262F;
    bottom: -4px;
  }

  .disabled-swipe {
    overscroll-behavior: contain;
    overflow: hidden !important;
  }

  .popup-arrow  {
    position: absolute !important;
    width: 17px !important;
    left: 3px !important;
  }

  ${getToastifyStyles}
`;

export {GlobalStyle};
